import { createSlice } from '@reduxjs/toolkit';
import { fetchAuditLog } from './auditLogThunks';
import type { AuditLogState } from './auditLogTypes';

const initialState: AuditLogState = {
  items: [], byId: {}, currentItem: null, status: 'idle', error: null, totalCount: 0,
};

// Slice read-only: niente addCrudCases (factory pensata per i 5 thunk CRUD),
// solo i tre case di fetchAuditLog. byId è popolato per coerenza con
// BaseEntityState anche se l'audit non si legge mai per id.
export const auditLogSlice = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLog.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAuditLog.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
        for (const entry of action.payload.items) state.byId[entry.id] = entry;
      })
      .addCase(fetchAuditLog.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ?? action.error.message ?? 'Errore';
      });
  },
});

export const auditLogReducer = auditLogSlice.reducer;
